import { render, staticRenderFns } from "./PortalList.vue?vue&type=template&id=2c21dba9&scoped=true&"
import script from "./PortalList.vue?vue&type=script&lang=js&"
export * from "./PortalList.vue?vue&type=script&lang=js&"
import style0 from "./PortalList.vue?vue&type=style&index=0&id=2c21dba9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c21dba9",
  null
  
)

export default component.exports